export const MAX_FILES = 5;
export const MAX_BYTES = 10 * 1024 * 1024;

const EXTS = new Set(['pdf', 'jpg', 'jpeg', 'png', 'heic']);
const MIMES = new Set(['application/pdf', 'image/jpeg', 'image/png', 'image/heic', 'image/heif']);
export const ACCEPT = '.pdf,.jpg,.jpeg,.png,.heic,application/pdf,image/jpeg,image/png,image/heic,image/heif';

function allowed(f: File): boolean {
  const ext = f.name.includes('.') ? f.name.split('.').pop()!.toLowerCase() : '';
  return EXTS.has(ext) || MIMES.has((f.type || '').toLowerCase());
}

export function checkFiles(files: File[], existingCount: number): { ok: File[]; errors: string[] } {
  const ok: File[] = [];
  const errors: string[] = [];
  let tooMany = false;
  for (const f of files) {
    if (!allowed(f)) {
      if (!errors.includes('Only PDF, JPG, PNG or HEIC files')) errors.push('Only PDF, JPG, PNG or HEIC files');
      continue;
    }
    if (f.size > MAX_BYTES) { errors.push(`${f.name} is larger than 10 MB`); continue; }
    if (existingCount + ok.length >= MAX_FILES) { tooMany = true; continue; }
    ok.push(f);
  }
  if (tooMany) errors.push('Up to 5 files');
  return { ok, errors };
}

export function formatSize(bytes: number): string {
  if (bytes < 1024) return `${bytes} B`;
  if (bytes < 1024 * 1024) return `${Math.round(bytes / 1024)} KB`;
  return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
}

export function isPdf(mime: string): boolean {
  return mime === 'application/pdf';
}
